import { AdjustCoinStatusTable } from './AdjustCoinStatusTable'
import withCoinHistoryTable from './withAdjustCoinStatusTable'

const ConnectedAdjustCoinStatusTable = withCoinHistoryTable(
  AdjustCoinStatusTable
)
export { ConnectedAdjustCoinStatusTable as AdjustCoinStatusTable }
